/* eslint-disable @typescript-eslint/no-explicit-any */
import { ELocalStorage } from '../../../../types/localStorageTypes';
import { getTokenByType } from '../../../../utils/localStorageUtil';

export enum ETagType {
  CATEGORIES = 'CATEGORIES',
  QUESTION_ANSWER = 'QUESTION_ANSWER',
  DOCUMENTS = 'DOCUMENTS',
  QUESTION_CATEGORIES = 'QUESTION_CATEGORIES',
  PROMPTS = 'PROMPTS',
  SETTINGS = 'SETTINGS',
  TEMPLATE_QUESTIONS = 'TEMPLATE_QUESTIONS',
}

export const tagTypes: string[] = [
  ETagType.CATEGORIES,
  ETagType.QUESTION_ANSWER,
  ETagType.DOCUMENTS,
  ETagType.PROMPTS,
  ETagType.QUESTION_CATEGORIES,
  ETagType.SETTINGS,
  ETagType.TEMPLATE_QUESTIONS,
];

export const tagTypesCategories: string[] = [ETagType.CATEGORIES];
export const tagTypesQuestionAnswer: string[] = [ETagType.QUESTION_ANSWER];
export const tagTypesDocuments: string[] = [ETagType.DOCUMENTS];
export const tagTypesPrompts: string[] = [ETagType.PROMPTS];
export const tagTypesQuestionCategories: string[] = [ETagType.QUESTION_CATEGORIES];
export const tagTypesSettings: string[] = [ETagType.SETTINGS];
export const tagTypesTemplateQuestions: string[] = [ETagType.TEMPLATE_QUESTIONS];

export const getBody = () => ({ token: getTokenByType(ELocalStorage.AdminRefreshToken) ?? null }) as any;

export const getPrepareHeaders = (headers: Headers) => {
  return headers.set('Authorization', `Bearer ${getTokenByType(ELocalStorage.AdminAccessToken)}`);
};
